import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { CoatHangerIcon } from '@fronton/icons-react';
import { DesignRegistrationPanel, PanelActionBlock } from 'common/components';
import {
  STORAGE_DESIGN_SIGN_UP_HREF,
  STORAGE_DESIGN_PROJECT_HREF,
  STORAGE_ELEMENT_BLOCK,
} from '../../storage-constants';

type StorageDesignPanelProps = {
  isRuRegion: boolean;
  regionId: string;
};

export const StorageDesignPanel = memo(({ isRuRegion, regionId }: StorageDesignPanelProps) => {
  const signUpHref = `${STORAGE_DESIGN_SIGN_UP_HREF}${regionId}`;
  const { t } = useTranslation();

  const addittionaAction = isRuRegion ? [{
    elementBlock: STORAGE_ELEMENT_BLOCK,
    invert: true,
    href: STORAGE_DESIGN_PROJECT_HREF,
    label: t('design-panel.button-first'),
    variant: 'pseudo',
  }] : [];

  return (
    <DesignRegistrationPanel
      isNewAnalytics
      structure={{
        panel: {
          content: {
            leftIcon: CoatHangerIcon,
            iconColor: 'text-invert',
            iconType: 'outline',
            text: t('design-panel.text'),
          },
          actionBlock: [
            ...addittionaAction as PanelActionBlock[],
            {
              elementBlock: STORAGE_ELEMENT_BLOCK,
              href: signUpHref,
              label: t('design-panel.button-second'),
              target: '_blank',
              variant: 'accent',
            },
          ],
        },
        mobilePanel: {
          content: {
            icon: CoatHangerIcon,
            iconColor: 'text-invert',
            iconType: 'outline',
            text: t('design-panel.text') || '',
          },
          mobileButton: {
            openModal: true,
            label: t('design-panel.button-first'),
          },
          actionBlock: [
            {
              elementBlock: STORAGE_ELEMENT_BLOCK,
              href: signUpHref,
              label: t('design-panel.button-second'),
              target: '_blank',
              variant: 'accent',
            },
            ...addittionaAction as PanelActionBlock[],
          ],
        },
      }}
    />
  );
});
